import DashboardScreenItem from './DashboardScreenItem';

export default DashboardScreenItem;
